import React from 'react';
import {
  BrowserRouter as Router,
  Redirect,
  Switch,
  Route,
} from 'react-router-dom';
import AuthRoute from './routes/AuthRoute';
import GuestRoute from './routes/GuestRoute';
import GeneralRoute from './routes/GeneralRoute';
import NotFound from './pages/errors/NotFound';
import MasterLayout from './layouts/Master';
import GeneralLayout from './layouts/GeneralLayout';
import AuthenticateLayout from './layouts/Authenticate';
import ThemeSwitcher from './components/ThemeSwitcher';
import SpecialRoute from './routes/SpecialRoute';
import SpecialLayout from './layouts/SpecialLayout';
import SubscriptionLimitedAuthRoute from './routes/SubscriptionLimitedAuthRoute';
import SubscriptionLimitedLayout from './layouts/SubscriptionLimitedLayout';
import { isSubscriptionLimited } from './module-params';

class App extends React.Component {
  render() {
    return (
      <>
        <ThemeSwitcher />
        <Router>
          <Switch>
            <Redirect exact from="/" to="/algos" />
            <SpecialRoute
              path="/user-login-by-admin"
              component={(props) => <SpecialLayout {...props} />}
            />
            <GeneralRoute
              path="/general"
              component={(props) => <GeneralLayout {...props} />}
            />
            <GuestRoute
              path="/auth"
              component={(props) => <AuthenticateLayout {...props} />}
            />
            {isSubscriptionLimited ? (
              <SubscriptionLimitedAuthRoute
                path="/"
                component={(props) => <SubscriptionLimitedLayout {...props} />}
              />
            ) : (
              <AuthRoute
                path="/"
                component={(props) => <MasterLayout {...props} />}
              />
            )}
            <Route component={NotFound} />
          </Switch>
        </Router>
      </>
    );
  }
}

export default App;
